/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_ChestInputs */

const en_us2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chest`)
};

const pt_br2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peito`)
};

const es_419_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pecho`)
};

const pt_pt2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peito`)
};

const fr_fr2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poitrine`)
};

const de_de2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brust`)
};

const it_it2_body_measures_site_chest = /** @type {(inputs: Body_Measures_Site_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petto`)
};

/**
* | output |
* | --- |
* | "Chest" |
*
* @param {Body_Measures_Site_ChestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_chest = /** @type {((inputs?: Body_Measures_Site_ChestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_ChestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_chest(inputs)
	if (locale === "es-419") return es_419_body_measures_site_chest(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_chest(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_chest(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_chest(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_chest(inputs)
	return en_us2_body_measures_site_chest(inputs)
});
export { body_measures_site_chest as "body-measures.site_chest" }